import React from "react";
import Footer from "./Footer";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import Header from "./Header";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <Header />

      <section className="trending">
        <div className="trending-inner">
          <div className="trending-head">
            <div>
              <h2>Shop Now</h2>
              <p className="trending-desc">
                From the not-so basics to the latest trending styles shop our
                top picks.
              </p>
            </div>
          </div>

          <div className="trending-grid">
            {productData.map((product) => {
              const price = parseFloat(product.price) || 0;
              const oldPrice = (price * 1.2).toFixed(2);
              const discount = Math.round(
                ((price - price * 1.2) / (price * 1.2)) * 100
              );
              return (
                <Link
                  onClick={toTop}
                  to={`/shopDetails/${product.id}`}
                  className="product-card"
                  key={product.id}
                >
                  <div className="product-media">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="product-meta">
                    <div className="brand">
                      {product.name.split(" ")[0].toLowerCase()}
                    </div>
                    <div className="title">{product.name}</div>
                    <div className="price-row">
                      <div className="price">£{price.toFixed(2)}</div>
                      <div className="old-price">£{oldPrice}</div>
                      <div className="discount">{Math.abs(discount)}%</div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Shop;
